import axios from 'axios';

export const getAuthCookie = async (env) => {

    try {

        const response = await axios.post(`${env}/globalauth-helpercomponent/auth-cookie`,
            {}, { withCredentials: true })


        return response?.data || {}

    } catch (error) {

        return {
            state: "failed"
        }

    }

}

export default getAuthCookie